module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS3.6a21e10e.jpg";